export default __webpack_public_path__ + "static/media/upload-icon.1c2b9d8e.svg";